import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import style from './style.module.less'

export default class extends Component {
  render() {
    const content = `
      <p style="line-height: 1.5em; text-align: left;">
        <span style="font-size: 14px;">尊敬的婚礼纪商家：<br>
        &nbsp; &nbsp; &nbsp; &nbsp; 感谢您一直以来的陪伴和包容，依据第三方支付平台的最新收费政策，自2020年6月29日0点起，婚礼纪平台不再承担商家本应支付给第三方支付平台0.6%服务费。敬请各位商家谅解。具体说明如下：<br>
        &nbsp; &nbsp; &nbsp; &nbsp; 订单支付服务费指第三方支付平台按照单笔交易金额收取一定比率的手续费，婚礼纪平台即时扣除并支付至第三方支付平台！<br>
        &nbsp; &nbsp; &nbsp; &nbsp; 感谢您的理解与支持，我们将继续努力为您提供更优质的服务。<br><br>
      </p>
    `

    return (
      <HeaderView title="通知说明">
        <div className={style.detail_content}>
          <h4 className={style.title}>
            《关于第三方支付平台收取手续费的通知和说明》
          </h4>
          <div
            className={style.content}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      </HeaderView>
    )
  }
}
